/**
 * コンテンツタイプの編集画面のフィールドをグループ化しグリッドデザインで段組にします。
 *
 * 使い方:
 * columnGroup({
 *   group: [{ key: 'someKey', label: 'Label', fields: [field1, field2] }],
 *   selector: '.target-selector',
 *   type: 'card',
 *   method: 'after',
 *   changeFormat: false
 * });
 *
 * @requires bootstrap
 * @param {Object} options 関数のオプション
 * @param {Array} options.group - グループとフィールドの情報を持った配列
 *    @param {Object} options.group[] - グループ情報
 *       @param {string} options.group[].key - グループのキー
 *       @param {string} options.group[].label - グループの表示名
 *       @param {Array} options.group[].fields - グループ内のフィールド情報
 *          @param {Object} options.group[].fields[] - フィールド情報
 *             @param {string} options.group[].fields[].label - フィールド名
 *             @param {string} options.group[].fields[].column - フィールドが占める列のクラス名
 * @param {string} options.selector - グループを挿入する起点となるノードのセレクタ
 * @param {string} options.type - グループの入れ物の種類。`card` か `collapse` のいずれか
 * @param {string} options.method - `after`, `before`, `prepend`, `append` のいずれか
 * @param {boolean} options.changeFormat - false を指定するとフォーマットを変更できなくなる
 */
import { getContentFieldIdByLabel } from './getContentFieldIdByLabel.js';
import { tidySeparator } from './tidySeparator.js';

export function columnGroup(options) {
    const defaultOptions = {
        group: [],
        selector: '',
        type: 'card',
        method: 'after',
        changeFormat: false
    };

    const op = { ...defaultOptions, ...options };

    if (!['view', 'edit'].includes(window.mtappVars.mode) || window.mtappVars.type !== 'content_data') {
        return;
    }

    const pointer = document.querySelector(op.selector);

    if (!pointer) {
        return;
    }

    if (op.method !== 'before' && op.method !== 'append') {
        op.group.reverse();
    }

    for (const group of op.group) {
        const groupKey = 'mtapp-column-group-' + group.key;
        const groupLabel = group.label;
        let groupHTML = '';

        if (op.type === 'card') {
            groupHTML = `
                <div class="card mb-5" id="${groupKey}">
                    <div class="card-header">${groupLabel}</div>
                    <div class="card-body">
                        <div class="row"></div>
                    </div>
                </div>
                `;
        } else if (op.type === 'collapse') {
            groupHTML = `
                <div class="mt-collapse mb-5">
                    <div class="mt-collapse__container">
                        <div class="col pl-4">${groupLabel}</div>
                        <div class="col-auto">
                            <a data-bs-toggle="collapse" href="#${groupKey}" aria-expanded="false" aria-controls="${groupKey}" class="d-block">
                                <svg title="Collapse" role="img" class="mt-icon--secondary">
                                    <use xlink:href="${window.mtappVars.static_path}/images/sprite.svg#ic_collapse"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                    <div class="collapse mt-collapse__content" id="${groupKey}">
                        <div class="row"></div>
                    </div>
                </div>
                `;
        }

        switch (op.method) {
            case 'after':
                pointer.insertAdjacentHTML('afterend', groupHTML);
                pointer.classList.add('mb-5');
                break;
            case 'before':
                pointer.insertAdjacentHTML('beforebegin', groupHTML);
                pointer.classList.add('mt-5');
                break;
            case 'prepend':
                pointer.insertAdjacentHTML('afterbegin', groupHTML);
                break;
            case 'append':
                pointer.insertAdjacentHTML('beforeend', groupHTML);
                break;
        }

        const row = document.querySelector(`#${groupKey} .row`);
        for (const field of group.fields) {
            if (typeof field.id === 'undefined') {
                if (typeof field.label === 'string') {
                    field.id = getContentFieldIdByLabel(field.label);
                } else {
                    console.error('field.label is required');
                    continue;
                }
            }
            const contentField = window.mtappVars.contentDataFields['contentField' + field.id];
            if (contentField) {
                if (!op.changeFormat) {
                    // フォーマットの変更が禁止されている場合、特定の要素を非表示にする
                    const selectElem = contentField.querySelector('select.convert_breaks');
                    if (selectElem) {
                        const parentElem = selectElem.parentElement;
                        parentElem.style.display = 'none';
                        parentElem.parentElement.classList.remove('mt-contentblock');
                    }
                }
                const div = document.createElement('div');
                div.classList.add('mtapp-group-column');

                tidySeparator(field.column, ' ')
                    .split(' ')
                    .forEach((col) => {
                        div.classList.add(col);
                    });
                div.appendChild(contentField);
                row.appendChild(div);
            }
        }
    }
}
